// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__APUMu","content":"FallbackPage_content__RYD6O"};